import React from 'react';
import { Radio } from './Radio';

interface RadioOption {
    value: string;
    label: string;
    description?: string;
    disabled?: boolean;
    'data-testid'?: string;
}

interface RadioGroupProps {
    name: string;
    options: RadioOption[];
    value?: string;
    onChange?: (value: string) => void;
    disabled?: boolean;
    className?: string;
}

export const RadioGroup: React.FC<RadioGroupProps> = ({
    name,
    options,
    value,
    onChange,
    disabled = false,
    className = ''
}) => {
    const handleChange = (optionValue: string) => {
        if (onChange && !disabled) {
            onChange(optionValue);
        }
    };

    return (
        <div className={`flex gap-l ${className}`}>
            {options.map((option) => (
                <Radio
                    key={option.value}
                    name={name}
                    value={option.value}
                    label={option.label}
                    description={option.description}
                    checked={value === option.value}
                    disabled={disabled || option.disabled}
                    onChange={() => handleChange(option.value)}
                    data-testid={option['data-testid']}
                />
            ))}
        </div>
    );
};